import React, { useState } from "react";
import { Tooltip } from "@material-ui/core";
import { NavLink } from "react-router-dom";

import { StyledCol, StyledTable, StyledTableBody, StyledTableHead, StyledTableRow } from "../../styles/styledTable";
import { StyledServiceBalancesDetailsWrapper, StyledServiceBalancesItemWrapper } from "../styledServiceBalances";
import { StyledBreakWord } from "../../styles/styledBreakWord";
import { StyledTooltip } from "../../styles/styledTooltip";

const ServiceBalancesItem = ({ data, t }) => {
  const [showDetails, setShowDetails] = useState(false);

  const { serviceName, value } = data;

  const connections = Object.values(value.connections);
  const cpBalances = Object.values(value.cpBalances);

  const showBalancesDetails = () => {
    setShowDetails(!showDetails);
  };

  return (
    <StyledServiceBalancesItemWrapper>
      <StyledTableRow
        onClick={() => showBalancesDetails()}
        scroll="auto"
        col="2"
        cursor="pointer"
        className={`service-balances-table__row ${showDetails ? "active" : ""}`}
      >
        <StyledCol>
          {serviceName}
        </StyledCol>
        <StyledCol>
          {cpBalances.map((balance, key) => {
            return (
              <div key={key} className="service-balances-table__balance">
                {balance.amount} {balance.currency}
              </div>
            );
          })}
        </StyledCol>
      </StyledTableRow>

      {showDetails &&
        <StyledServiceBalancesDetailsWrapper>
          {connections.map((connection, index) => {
            let connectionClients = Object.entries(connection.clients);
            let connectionProdBalance = connection.prodBalances ? Object.values(connection.prodBalances) : null;

            return (
              <div key={index}>
                <div className="service-balance-details-head">
                  <div className="service-balance-details-head__name">
                    Connection {index + 1}
                  </div>
                  {connectionProdBalance &&
                    <div className="service-balance-details-head__balance">
                      <div className="service-balance-details-head__balance-title">
                        {t("table.prodBalance")}
                        <Tooltip
                          title={t("table.tooltips.prodBalance")}
                          arrow
                          placement="top"
                        >
                          <StyledTooltip className="icon-light-help" />
                        </Tooltip>
                        :
                      </div>
                      {connectionProdBalance.map((prodBalance, index) => {
                        return (
                          <div key={index}>
                            {prodBalance.amount} {prodBalance.currency}
                          </div>
                        );
                      })}
                    </div>}
                </div>
                <div className="service-balance-details-body">
                  <StyledTable
                    width="768"
                    size="14"
                    className="clients-service-balances"
                  >
                    <StyledTableHead
                      scroll="auto"
                      col="2"
                      className="clients-service-balances__head"
                    >
                      <div>
                        {t("table.clients")}
                      </div>
                      <div>
                        {t("table.cpBalance")}
                        <Tooltip
                          title={t("table.tooltips.cpBalance")}
                          arrow
                          placement="top"
                        >
                          <StyledTooltip className="icon-light-help" />
                        </Tooltip>
                      </div>
                    </StyledTableHead>
                    <StyledTableBody>
                      {connectionClients.map((client, index) => {
                        let clientBalances = Object.values(client?.[1]);

                        return (
                          <StyledTableRow
                            key={index}
                            scroll="auto"
                            col="2"
                            className="clients-service-balances__row"
                          >
                            <StyledCol inline>
                              <StyledBreakWord as={NavLink} to={`/clients?email=${client[0]}`}>
                                  {client[0]}
                              </StyledBreakWord>
                              {/*cash-flow?page=1&itemsPerPage=30&currentTab=transactions&currency.asset=UAH&connection.service.name=Hryvnia8&connection.project.user.email=ad1@asdasd*/}
                            </StyledCol>
                            <StyledCol>

                              {clientBalances.map((balance, index) => {
                                return (
                                  <div key={index}>
                                    <StyledBreakWord as={NavLink} to={`/cash-flow?currentTab=transactions&connection.service.name=${serviceName}&connection.project.user.email=${client[0]}`}>
                                      {balance.amount} {balance.currency}
                                    </StyledBreakWord>
                                  </div>
                                );
                              })}
                            </StyledCol>
                          </StyledTableRow>
                        );
                      })}
                    </StyledTableBody>
                  </StyledTable>
                </div>
              </div>
            );
          })}
        </StyledServiceBalancesDetailsWrapper>
      }
    </StyledServiceBalancesItemWrapper>
  );
};

export default ServiceBalancesItem;